/// <reference path='../definition/greensock.d.ts' />
/// <reference path='../definition/jquery.d.ts' />
/// <reference path='../patterns/gsap-interface.ts' />

const PictureControl_OBJECTFIT_SUPPORT = (('objectFit' in document.documentElement.style === true));

class PictureControl {
    initialized: boolean = false;
    shown: boolean = false;
    name: string = 'PictureControl';
    img: HTMLPictureElement;
    /* padding: number; */

    constructor(private element: HTMLElement, id: number) {
        this.img = element.querySelectorAll('img')[0] as HTMLPictureElement;
        this.name += id;
        /* this.padding = this.img.offsetHeight / this.img.offsetWidth * 100; */
        if (!PictureControl_OBJECTFIT_SUPPORT) {
            this.img.style.display = 'none';
            this.element.style.backgroundImage = 'url(' + this.img.getAttribute("src") + ')';
            this.element.style.backgroundSize = 'cover';
            /* this.element.style.paddingBottom = `${this.padding}%`; */
            
        }

        this.resize();
    }

    public init(): any {
        this.initialized = true;
    }

    public resize() {
        if (!this.initialized) return false;
    }
}
